import React, {useContext, useState} from 'react';
import {AmplifyContainer} from "@aws-amplify/ui-react";
import styles from "./custom-confirm-signin.module.scss";
import {Button, Col, Container, Form, Row, Spinner} from "react-bootstrap";
import Alert from "../alert/alert";
import passwordIcon from "../../assets/login-password-icon.svg";
import {AUTH_INVALID_CODE} from "../../helpr/constants";
import {changeAuthState, cognitoConfirmSignIn} from "../../helpr/authHelper";
import {IdentityContext} from "../../context/identity-context";
import InvalidMfaCodeError from "../../models/errors/invalid-mfa-code-error";
import {AuthState} from "@aws-amplify/ui-components";

const CustomConfirmSignIn = () => {
  /*
    Initiate mfa form state
   */
  const { initialUser } = useContext(IdentityContext);
  const [page, setPage] = useState(0);
  const [mfaState, setMfaState] = useState({onConfirm:false});
  const [showErr, setShowErr] = useState({
    msg: '',
    type: 'alert-danger-custom',
    isVisible: false ,
    onClose: ()=>setShowErr({
      ...showErr,
      ['isVisible']: false
    })
  });
  /*
    Set sign in form on change of fields
   */
  const onChange = (e) => {
    const value = e.target.value;
    setMfaState({
      ...mfaState,
      [e.target.id]: value
    });
  }

  /*
    Handle sign in event
   */
  const confirmSignIn = async(e) => {
    e.preventDefault();
    setMfaState({
      ...mfaState,
      onLogin: true
    });
    const { otp } = mfaState;

    try {
      /*
        Custom fields validation
       */
      if (!otp) {
        throw new Error(AUTH_INVALID_CODE);
      }

      console.log("Signing in...");
      await cognitoConfirmSignIn(initialUser, otp);

    } catch (error) {
      if (error instanceof InvalidMfaCodeError){
        /*
        Display error message in UI
       */
        setShowErr({
          ...showErr,
          ['isVisible']: true,
          msg: error.message,
          type: 'alert-danger-custom',
        });
      }
      else {
        setPage(1);
      }
    } finally {
      setMfaState({
        ...mfaState,
        onLogin: false
      });
    }
  }

  const backToLogin = async () => {
    await changeAuthState(AuthState.SignIn);
    setPage(0)
  }

  /*
    JSX Markup for custom sign up form
   */
  return (
    <AmplifyContainer className={styles['custom-container']} slot="confirm-sign-in">
      <Container>
        {page === 0 ?
          <Row>
            <Col lg={{span: 4, offset: 4}}>
              <Alert
                options={showErr}
              />
              <div className={styles['app-title-section']}>
                <span>{process.env.REACT_APP_TITLE}</span>
              </div>
              <div className={styles['mfa-title-section']}>
                <span>A one-time pin has been sent to your registered email.</span>
              </div>
              <div className={styles['form-section']}>
                <Form onSubmit={confirmSignIn}>
                  <Form.Group className={styles['input-section']} controlId="otp">
                    <i className={styles['icon']}><img src={passwordIcon}/></i>
                    <Form.Control
                      className={styles['mfa-input']}
                      type="otp"
                      placeholder="Enter one-time pin"
                      onChange={onChange}/>
                  </Form.Group>
                  <div>
                    <Button disabled={mfaState.onConfirm} className={styles['proceed-button']} variant="primary"
                            type="submit">
                      {mfaState.onConfirm ? <Spinner size="sm" animation="border"/> : 'SUBMIT'}
                    </Button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
          :
          <Row>
            <Col lg={{span: 4, offset: 4}}>
              <div className={styles['app-title-section']}>
                <span>{process.env.REACT_APP_TITLE}</span>
              </div>
              <div className={styles['mfa-title-section']}>
                <span>You can only enter the wrong otp a maximum of 3 times.</span>
              </div>
              <div className={styles['form-section']}>
                <Button className={styles['back-button']} variant="primary" onClick={() => backToLogin()} >
                  BACK TO LOGIN
                </Button>
              </div>
            </Col>
          </Row>
        }
      </Container>
    </AmplifyContainer>
  )
}

export default CustomConfirmSignIn;
